module.exports = __webpack_public_path__ + "images/de7f9ad4c6c567cc15dcfacee866ef20.svg";